<template>
    <div class="login-container">
        <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" auto-complete="on"
                 label-position="left">
            <h3 class="title">{{systemTitle}}</h3>
            <el-form-item prop="username">
        <span class="svg-container">
          <!--<svg-icon icon-class="user" />-->
        </span>
                <el-input v-model="loginForm.username" name="username" type="text" placeholder="请输入用户名"/>
            </el-form-item>
            <el-form-item prop="password">
        <span class="svg-container">
          <!--<svg-icon icon-class="password" />-->
        </span>
                <el-input
                    :type="pwdType"
                    v-model="loginForm.password"
                    name="password"
                    placeholder="请输入密码"
                    @keyup.enter.native="handleLogin"/>
                <span class="show-pwd" @click="showPwd">
          <!--<svg-icon :icon-class="pwdType === 'password' ? 'eye' : 'eye-open'" />-->
        </span>
            </el-form-item>
            <el-form-item>
                <el-button :loading="loading" type="primary" class="login-btn" @click.native.prevent="handleLogin">
                    登&nbsp;&nbsp;&nbsp;录
                </el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import UserApi from '../../../../apis/UserApi';
import md5 from 'js-md5';
export default {
    name: 'Login',
    data()
    {
        return {
            loginForm: {
                username: '',
                password: ''
            },
            loginRules: {
                username: [{required: true, message: '请输入用户名', trigger: 'blur'}],
                password: [{required: true, message: '请输入密码', trigger: 'blur'}]
            },
            systemTitle: this.$root.$data.system.title,
            loading: false,
            pwdType: 'password',
        }
    },
    beforeMount()
    {
        document.title = this.$root.$data.system.title;
        return Fx.Promise.then(() =>
        {
            // return Fx.Http.post("/system/constant/export").
            // then((resp) =>
            // {
            //     if(resp.isSuccess())
            //     {
            //         top.Constant = resp.getData();
            //         Fx.$globalVue.__proto__.$topConstant = top.Constant;
            //     }
            // });
        });
    },
    methods:
    {
        showPwd()
        {

        },
        handleLogin()
        {
            this.$refs.loginForm.validate(valid =>
            {
                if(!valid) return;
                this.loading = true;
                // return Fx.Http.post('/system/user/login', this.loginForm).
                return UserApi.login({username: this.loginForm.username, password: md5(this.loginForm.password)}).
                then((response) =>
                {
                    if(response.isSuccess() && response.getData('result'))
                    {
                        this.$store.commit('session/setSessionUser', {
                            userId: response.getData("userId"),
                            username: response.getData("username"),
                            nickname: response.getData("nickname")
                        });
                        this.$message({
                            message: '登录成功',
                            type: 'success',
                            duration: 1000,
                            onClose: ()=>
                            {
                                let redirect = this.$route.query.redirect;
                                if(redirect)
                                {
                                    this.$router.replace(redirect);
                                }
                                else
                                {
                                    this.$router.replace('/');
                                }
                            }
                        });
                    }
                    else
                    {
                        this.loading = false;
                        console.log('error', response);
                        this.$message.error(response.getErrorMessage());
                    }
                }).
                catch(err =>
                {
                    this.loading = false;
                    console.error('login error', err);
                });
            });
        }
    }
}
</script>
<style>
.login-container {
    height: 100%;
    width: 100%;
    background-color: #2d3a4b;
    display: flex;
    justify-content: center;
}

.login-container .login-form {
    margin: 150px auto;
    padding: 35px;
    width: 400px;

}

.login-container .title {
    font-size: 26px;
    color: #eeeeee;
    text-align: center;
    font-weight: bold;
    margin: 0px auto 40px auto;
}

.login-container .login-btn {
    width: 100%;
    font-size: 18px;
}

/*.login-container .svg-container*/
/*{*/
/*padding: 6px 5px 6px 15px;*/
/*color: #eeeeee;*/
/*vertical-align: middle;*/
/*display: inline-block;*/
/*}*/

</style>



// WEBPACK FOOTER //
// src/modules/common/pages/login/Login.vue